export const config = {
  ADDRESS_AUTOCOMPLETE_PROVIDER:
    process.env.ADDRESS_AUTOCOMPLETE_PROVIDER || null,
  MAPBOX_ACCESS_TOKEN: process.env.MAPBOX_ACCESS_TOKEN || null,
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY || null,
}
